var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"bg-white p-4 mt-5 rounded"},[_c('h1',{staticClass:"text-center"},[_vm._v("\n      "+_vm._s(_vm.$t("registration.heading"))+"\n    ")]),_c('hr'),_c('RegistrationForm')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }